module.exports = __webpack_public_path__ + "static/media/check.d8fe59d7.svg";